import classNames from 'classnames';
import Image from 'next/image';
import React from 'react';

import { loadAsset } from '@cineamo/ui/src/helpers/asset-helper';

const moviePlaceholderImage = loadAsset('/images/placeholders/landscape/im-posterFilmLandscape.jpg');

/**
 * Pure presentational component for displaying a movie backdrop/header image.
 * Shows movie backdrop with optional gradient mask and overlay.
 * Displays movie title overlay when using placeholder.
 */
const MovieBackdropImage: React.FC<{
    className?: string;
    /** Extra classes applied to the inner <Image> itself (e.g. a Ken-Burns zoom animation). */
    imageClassName?: string;
    // Optional: `MovieDto.title` is not guaranteed for every locale.
    movieTitle?: string;
    movieBackdropImage?: string;
    movieBackdropBlurDataImage?: string;
    width?: number;
    height?: number;
    showGradient?: boolean;
    showOverlay?: boolean;
}> = ({
    className,
    imageClassName,
    movieTitle,
    movieBackdropImage,
    movieBackdropBlurDataImage,
    width = 1500,
    height = 500,
    showGradient = true,
    showOverlay = true
}) => {
    return (
        <div className={classNames(className, 'relative w-auto h-full overflow-hidden')}>
            <Image
                className={classNames(
                    'w-full h-full object-cover',
                    showGradient && 'gradient-mask-b-20',
                    imageClassName
                )}
                width={width}
                height={height}
                src={movieBackdropImage || moviePlaceholderImage}
                alt={movieTitle ?? ''}
                placeholder={movieBackdropBlurDataImage ? 'blur' : 'empty'}
                blurDataURL={movieBackdropBlurDataImage ? movieBackdropBlurDataImage : undefined}
                priority
            />
            {showOverlay && (
                <div className="absolute left-0 top-0 bg-black w-full h-full opacity-25 gradient-mask-b-0" />
            )}
            {!movieBackdropImage && (
                <span
                    className="absolute bottom-0 w-full text-center text-body-bold-12 text-white p-6 break-words whitespace-pre-wrap
                    h-auto select-none">
                    {movieTitle}
                </span>
            )}
        </div>
    );
};

export default MovieBackdropImage;
